/* eslint-disable import/no-cycle */
import { Options as HighchartsOptions } from 'highcharts';

import { STATIC_ELEMENT_HEIGHT, STATIC_POINT_HEIGHT } from '../../constants';
import { CHART_WIDTH, MIN_15 } from '../../scenes/Scheduling/config';
import { formatScheduleElementLabel } from '../../scenes/Scheduling/utils/formatUtils';
import { positioner } from '../../scenes/Scheduling/utils/positioner';

const baseTimezoneOffset = new Date(0).getTimezoneOffset();
export const baseTimezoneOffsetInMs = baseTimezoneOffset * 60 * 1000;

export const chartConfig: HighchartsOptions = {
  credits: {
    enabled: false,
  },
  chart: {
    spacingLeft: 0,
    spacingRight: 0,
    spacingTop: 0,
    spacingBottom: 0,
    marginBottom: 15,
    width: CHART_WIDTH,
    height: 0,
    style: {
      fontFamily: 'Roboto, sans-serif',
    },
  },
  exporting: {
    enabled: false,
  },
  series: [
    {
      type: 'gantt',
      data: [],
    },
  ],
  plotOptions: {
    gantt: {
      states: {
        normal: {
          animation: false,
        },
      },
      borderRadius: 2,
      pointWidth: STATIC_POINT_HEIGHT,
    },
    series: {
      enableMouseTracking: true,
      dataLabels: {
        enabled: true,
        formatter: formatScheduleElementLabel,
        style: {
          fontSize: '12px',
        },
      },
      allowPointSelect: false,
      animation: {
        duration: 0,
      },
    },
  },
  yAxis: {
    categories: [],
    min: 0,
    max: 6,
    staticScale: STATIC_ELEMENT_HEIGHT,
    grid: {
      enabled: false,
    },
    title: {
      text: '',
    },
    labels: {
      enabled: false,
    },
  },
  xAxis: [
    {
      categories: [],
      grid: {
        enabled: false,
      },
      title: {
        text: '',
      },
      labels: {
        enabled: false,
      },
      currentDateIndicator: false,
      tickInterval: MIN_15,
      className: 'zoom-xAxis-minutes',
    },
  ],
  time: {
    timezoneOffset: baseTimezoneOffset,
  },
  tooltip: {
    positioner,
    xDateFormat: '%a %b %d, %H:%M',
    backgroundColor: '#fff',
    borderWidth: 0,
    useHTML: true,
    padding: 0,
    shadow: false,
    shape: 'square',
    style: {
      fontSize: '14px',
    },
    followPointer: true,
    outside: true,
  },
};
